import script from "./CommandPalette.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommandPalette.vue?vue&type=script&setup=true&lang=ts"

import "./CommandPalette.vue?vue&type=style&index=0&id=7073ecca&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7073ecca"]])

export default __exports__